import { useAccountSwitcherUiAPIInterface } from "@dealer-center/ddc-pages-account-switcher-ui-fetch";
import type { AccountSwitcherUiAPIInterfaceInternal } from "@dealer-center/ddc-pages-account-switcher-ui-interface";
import { Box, Modal, ModalContent } from "@dealer-center/core-components";
import { useNavigate, useParams } from "react-router-dom";

export const PagesAccountSwitcherUiUiModal = () => {
  const { searchValue, record } = useParams();
  const { data } = useAccountSwitcherUiAPIInterface({
    searchValue
  });
  const navigate = useNavigate();
  const selectedRecord = data?.find(
    (item: AccountSwitcherUiAPIInterfaceInternal) => item.key === record
  );

  return (
    <Modal
      header={`Images for ${selectedRecord?.name}`}
      show={!!selectedRecord}
      size="large"
      onHide={() => navigate(`/accountSwitcherUi/${searchValue}`)}
    >
      <ModalContent>
        <Box
          sx={{
            display: "grid",
            gap: 2,
            gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))"
          }}
        >
          {selectedRecord?.images.map((image, i) => (
            <Box
              key={image}
              sx={{
                overflow: "hidden",
                position: "relative",
                paddingBottom: "100%"
              }}
            >
              <img
                alt={selectedRecord?.name}
                src={image}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover"
                }}
              />
            </Box>
          ))}
        </Box>
      </ModalContent>
    </Modal>
  );
};
